import { Badge } from '@/components/ui/badge'
import {
  jobScheduleStateBadgeClasses,
  jobScheduleStateLabels,
} from '@/lib/job-list-display'
import { cn } from '@/lib/utils'

type JobOverdueBadgeProps = {
  className?: string
}

export function JobOverdueBadge({ className }: JobOverdueBadgeProps) {
  return (
    <Badge
      variant="outline"
      className={cn(jobScheduleStateBadgeClasses.overdue, className)}
    >
      {jobScheduleStateLabels.overdue}
    </Badge>
  )
}
